import { render, staticRenderFns } from "./SaveNewFilterModal.vue?vue&type=template&id=3d8520fa"
import script from "./SaveNewFilterModal.vue?vue&type=script&lang=js"
export * from "./SaveNewFilterModal.vue?vue&type=script&lang=js"
import style0 from "./SaveNewFilterModal.vue?vue&type=style&index=0&id=3d8520fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports